import {
    Button,
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from '@repo/shadcn';
import { format } from 'date-fns';
import { useFormContext } from 'react-hook-form';

import { TextField } from '@components/form/fields';

import { useCreateStockAdjustmentContext } from './context';
import { CreateStockAdjustment } from './schema';

export const StockVariationList = () => {
    const { batchesData, selectedProductName, selectedProductId } =
        useCreateStockAdjustmentContext();

    const { watch } = useFormContext<CreateStockAdjustment>();

    const watchedItems = watch('items');

    let isSubmitDisabled = true;

    const changedFieldIndex = watchedItems.findIndex(
        (field) => field.quantity !== 0,
    );

    if (changedFieldIndex >= 0) {
        isSubmitDisabled = false;
    }

    if (!selectedProductId || !selectedProductName) {
        return (
            <Card className={'p-4'}>
                <p className={'py-6 text-center'}>
                    Please select a product to see its stock variations.
                </p>
            </Card>
        );
    }

    return (
        <Card className={'p-4'}>
            <h3 className={'mb-4'}>
                Stock Variations for{' '}
                <span className={'font-medium'}>{selectedProductName}</span>
            </h3>

            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="">Batch ID</TableHead>
                        <TableHead>Expiry Date</TableHead>
                        <TableHead className={'text-right'}>
                            Current Quantity
                        </TableHead>
                        <TableHead className="text-right">Adjust</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {batchesData?.data?.map((batch: any, index: number) => {
                        return (
                            <TableRow>
                                <TableCell className="font-medium uppercase">
                                    {batch.purchase_id}
                                </TableCell>
                                <TableCell>
                                    {format(
                                        batch.expiration_date,
                                        'dd/MM/yyyy',
                                    )}
                                </TableCell>
                                <TableCell className={'text-right'}>
                                    {batch.quantity}
                                </TableCell>
                                <TableCell className="flex justify-end text-right">
                                    <TextField<CreateStockAdjustment>
                                        name={`items.${index}.quantity`}
                                        className={'text-right'}
                                        type={'number'}
                                        inputClass={'text-right max-w-[100px]'}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>

            <div className={'mt-4 px-4'}>
                <div className={'mb-4'}>
                    <TextField<CreateStockAdjustment>
                        name={'note'}
                        label={'Note'}
                        placeholder={'Enter note for this adjustment'}
                        required={true}
                    />
                </div>

                <div className={'flex justify-end'}>
                    <Button type={'submit'} disabled={isSubmitDisabled}>
                        Update
                    </Button>
                </div>
            </div>
        </Card>
    );
};

StockVariationList.displayName = 'StockVariationList';
